/**
 * Marks <html> with .targeting-consent while the shopper's OneTrust Targeting Cookies group (C0004, where Nosto sits)
 * is on; the rule in main.css hides every Nosto recommendation block without it. Runs on every page from the bundle.
 *
 * OneTrust keeps the active groups in window.OnetrustActiveGroups (",C0001,C0004,"). The SDK may not have loaded
 * when the bundle runs, so this checks now and again on every OneTrustGroupsUpdated, which it relies on OneTrust
 * firing on window when it loads as well as on each consent change. An update that drops C0004 takes the class off.
 */

const TARGETING_GROUP = 'C0004';
const CONSENT_CLASS = 'targeting-consent';

const hasTargetingConsent = () => (window.OnetrustActiveGroups || '').split(',').includes(TARGETING_GROUP);

const syncConsentClass = () => {
  const root = document.documentElement;
  const consented = hasTargetingConsent();
  if (consented === root.classList.contains(CONSENT_CLASS)) return;

  root.classList.toggle(CONSENT_CLASS, consented);
  if (!consented) return;

  // A Nosto carousel filled while hidden measured itself at zero width and stays an empty strip until a resize. The
  // resize also rebuilds the theme's own sliders, so it only fires when a block already has content; a block Nosto
  // fills from here on is visible and measures itself.
  const blocks = document.querySelectorAll('.nosto_element, .nosto-dynamic');
  if ([...blocks].some((block) => block.childElementCount > 0)) window.dispatchEvent(new Event('resize'));
};

syncConsentClass();
window.addEventListener('OneTrustGroupsUpdated', syncConsentClass);
